import { BigNumber, utils } from 'ethers';

import useGetEngagementByAddress from '../../hooks/useGetEngagementByAddress';
import { InfoDataProps, RewardsStateProps } from '../../hooks/types';

import { useFormatter, NumberType } from '../../utils/formatNumbers';
import { useEffect, useState } from 'react';
import { getEngagementSeason } from './rewards.service';

import { useAccount } from 'wagmi';

const BottomBlock = ({
  stateRewards,
  state,
}: {
  stateRewards: RewardsStateProps;
  state: {
    data: InfoDataProps;
    fetchData: () => void;
  };
}) => {
  const { data } = state;
  const { stakingTokenDecimals } = data;
  const { totalReward, getTier, getDiscount } = stateRewards;
  const { bondBuyCount, bondCreateCount, swordStake, bondRedeemCount, bondSellCount, kosDiscount } =
    useGetEngagementByAddress();
  const { formatNumberOrString } = useFormatter();
  const {address: account} = useAccount();

  const [seasonId, setSeasonId] = useState('');

  useEffect(() => {
    getEngagementSeason().then(setSeasonId);
  }, [account]);

  return (
    <div className="bottom-block">
      <div className="block_content">
        <div className="block_content__left">
          <h4 className="block_content__title">My rewards</h4>
          <ul className="block_content__list">
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                AMB rewards
              </span>
              <span className="block_content__list-item-value">
                {`${formatNumberOrString({
                  input: utils.formatUnits(
                    totalReward.toString(),
                    stakingTokenDecimals,
                  ),
                  type: NumberType.TokenNonTx,
                })} AMB`}
              </span>
            </li>
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                Staking Tier
              </span>
              <span className="block_content__list-item-value">
                {!BigNumber.from(getTier.level).isZero()
                  ? `Tier ${parseInt(getTier.level.toString(), 16)}`
                  : '-'}
              </span>
            </li>
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                Platform fee discount
              </span>
              <span className="block_content__list-item-value">
                {getDiscount}%
              </span>
            </li>
          </ul>
        </div>
        <div className="block_content__right">
          <h4 className="block_content__title">Season {seasonId} engagement</h4>
          <ul className="block_content__list">
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                Bonds purchased
              </span>
              <span className="block_content__list-item-value">
                {bondBuyCount}
              </span>
            </li>
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                Bond created
              </span>
              <span className="block_content__list-item-value">
                {bondCreateCount}
              </span>
            </li>
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                $KOS staked
              </span>
              <span className="block_content__list-item-value">
                {formatNumberOrString({
                  input: utils.formatUnits(swordStake, stakingTokenDecimals),
                  type: NumberType.TokenNonTx,
                })}
              </span>
            </li>
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                Bond Claimed
              </span>
              <span className="block_content__list-item-value">
                {bondRedeemCount}
              </span>
            </li>
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                Bond Sold
              </span>
              <span className="block_content__list-item-value">
                {bondSellCount}
              </span>
            </li>
            <li className="block_content__list-item">
              <span className="block_content__list-item-label">
                $KOS Discount
              </span>
              <span className="block_content__list-item-value">
                {!!kosDiscount && +utils.formatEther(kosDiscount) * 100}%
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BottomBlock;
